import { HeaderLogo } from "@/components/header-logo/index";
import { useContextPageRoot } from "../../context/root-context";

export const HeaderNavigateLogo = () => {
  const { localization } = useContextPageRoot();
  const { currentLang } = localization;

  return <HeaderLogo href={`/${currentLang}/home`} />;
};
